export const styles = () => ({
  gridMarginWrapper: {
    marginTop: 30,
  },
  image: {
    paddingRight: 8,
    height: 50,
  },
});
